import { NgModule } from '@angular/core';

import { PermissionModule } from './permission';
import { AuthorizationModule } from './authorization';

@NgModule({
  declarations: [],
  exports: [
    PermissionModule,
    AuthorizationModule
  ]
})
export class SecurityModule { }



// WEBPACK FOOTER //
// /dist/src/app/security/security.module.ts